module.exports = __webpack_public_path__ + "static/crater-app-record-c2c8f25a09b83af2425d74790651a6c3.jpg";